// extracted by mini-css-extract-plugin
export default {"inner-circle-container":"LVMK4","pie-chart-segment":"qVf7I","pie-chart-label":"Bxb4z","pie-chart-svg":"cPvjX"};